import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Scalefutureai() {
  return (
    <section className="scale_future_ai p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="resp_order mt-4 mt-md-0"
          >
            <StaticImage
              src="../../images/services-usa/ai/solution_ai.webp"
              alt="tekrevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={751}
              height={813}
            />
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>
              Scaleup Your Business with {}
              <span>AI Application Development Services</span>
            </h2>
            <p>
              TekRevol has witnessed businesses solving their most complex
              challenges with artificial intelligence and its most advanced
              forms. We have helped our clients utilize machine learning
              algorithms, neural networks and large language models to:
            </p>
            <ul>
              <li>Decrease operational and manufacturing costs</li>
              <li>Enhance and error-proof decision-making</li>
              <li>Transform customer engagement</li>
              <li>Personalize the shopping experiences</li>
              <li>Create new product and service lines</li>
              <li>Build new revenue streams</li>
              <li>Detect fraud and secure financial setups</li>
              <li>Facilitate their workforce</li>
              <li>Enable new ways of getting work done</li>
            </ul>
            <p>
              In short, TekRevol’s AI app development services help businesses
              automate operations for increased efficiency. With an AI solution
              provider like TekRevol, you unlock the untapped potential in your
              market, scale the demand generation efforts, reshape the working
              structure and most importantly, reimagine the possibilities of
              tenfold growth. Want to get first-hand experience of AI-powered
              software? Share your unique business problems and challenges with
              our solution development strategists and we’ll take it from there.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Book a call
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Scalefutureai;
